// extracted by mini-css-extract-plugin
module.exports = {"blocked":"ToggleAdultContent-module__blocked___oxONA"};